import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';

import { Input, Autocomplete } from '@/components/form';
import ResourceForm from '@/components/resources/form';
import View from '@/components/view';

const TypeForm = ({ match }) => {
  return (
    <View>
      <ResourceForm resource="Category" id={match.params.id} initialValues={{ name: '', parameters: {} }}>
        {({ submitting, renderActions }) => (
          <>
            <Card>
              <CardBody className={submitting ? 'loading' : ''}>
                <Row>
                  <Col lg={6}>
                    <Input name="name" />
                  </Col>
                  <Col lg={6} className="d-flex align-items-center">
                    <Autocomplete
                      name="parent"
                      resource="Category"
                      autoload
                      tag="name"
                      display="name"
                      clearable
                      className="w-100"
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <div className="mt-4 mb-4">{renderActions()}</div>
          </>
        )}
      </ResourceForm>
    </View>
  );
};

TypeForm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
  }).isRequired
};

export default TypeForm;
